import { render, staticRenderFns } from "./SelectReportType.vue?vue&type=template&id=6367239f&"
import script from "./SelectReportType.vue?vue&type=script&lang=js&"
export * from "./SelectReportType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports